import { fontSizes } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const message = (theme) => ({
  backgroundColor: theme === 'dark' ? colors.n4.base : colors.n9.base,
  boxSizing: 'border-box',
  color: theme === 'dark' ? colors.n8.base : colors.n5.base,
  fontSize: fontSizes.small,
  lineHeight: '16px',
  padding: '14px 12px',
  textAlign: 'center',
  width: '100%',
})

export const styles = { message }
